export default __webpack_public_path__ + "static/media/month-analysis.f8ca860c.svg";